import { Navigate } from "react-router-dom";
import { getUser } from "../api/auth";

export function getFirstAllowedRoute(user) {
    if (!user) return "/login";

    const map = {
        Dashboard: "/user",
        Templates: "/user/templates",
        Creatives: "/user/creatives",
        Campaigns: "/user/campaigns",
        Brands: "/user/brands",
        "XML Tester": "/user/xml-tester",
        "QR Generator": "/user/qr-generator",
    };

    const permission = user.permissions?.find((p) => p.per_view);
    return map[permission?.per_name] || "/unauthorized";
}

export default function PermissionRoute({
    children,
    permission,
}) {
    const user = getUser();

    if (user?.role === "admin") {
        return children;
    }

    const hasPermission = user?.permissions?.some(
        p =>
            p.per_name === permission &&
            p.per_view
    );

    if (!hasPermission) {
        return (
            <Navigate
                to={getFirstAllowedRoute(user)}
                replace
            />
        );
    }

    return children;
}